import * as React from "react";
import type { SVGProps } from "react";
const SvgDollarCircleAbout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <path
      fill="#3C7DFF"
      d="M24 43.8c11.046 0 20-8.953 20-20 0-11.045-8.954-20-20-20s-20 8.955-20 20c0 11.046 8.954 20 20 20Z"
      opacity={0.4}
    />
    <path
      fill="#3C7DFF"
      d="m28.52 24-3.02-1.06v-6.78h.72c1.62 0 2.94 1.42 2.94 3.16 0 .82.68 1.5 1.5 1.5s1.5-.68 1.5-1.5c0-3.4-2.66-6.16-5.94-6.16h-.72V12c0-.82-.68-1.5-1.5-1.5s-1.5.68-1.5 1.5v1.16h-1.3c-2.96 0-5.38 2.5-5.38 5.56 0 3.58 2.08 4.72 3.66 5.28l3.02 1.06v6.76h-.72c-1.62 0-2.94-1.42-2.94-3.16 0-.82-.68-1.5-1.5-1.5s-1.5.68-1.5 1.5c0 3.4 2.66 6.16 5.94 6.16h.72V36c0 .82.68 1.5 1.5 1.5s1.5-.68 1.5-1.5v-1.16h1.3c2.96 0 5.38-2.5 5.38-5.56-.02-3.6-2.1-4.74-3.66-5.28Zm-8.04-2.82c-1.02-.36-1.64-.7-1.64-2.44 0-1.42 1.06-2.56 2.38-2.56h1.3v5.72l-2.04-.72Zm6.32 10.66h-1.3v-5.72l2.02.7c1.02.36 1.64.7 1.64 2.44 0 1.42-1.06 2.58-2.36 2.58Z"
    />
  </svg>
);
export default SvgDollarCircleAbout;
